import type { StreakDistribution } from '@/core/types';

type Bucket = { key: keyof StreakDistribution; label: string; color: string };

const BUCKETS: Bucket[] = [
  { key: 's0', label: '0', color: '#E0E0E0' },
  { key: 's1', label: '1', color: '#FFCDD2' },
  { key: 's2', label: '2', color: '#FFF59D' },
  { key: 's3', label: '3', color: '#C8E6C9' },
  { key: 's4plus', label: '4+', color: '#BBDEFB' },
];

export function StreakDistributionBar({ distribution }: { distribution: StreakDistribution }) {
  const total =
    distribution.s0 + distribution.s1 + distribution.s2 + distribution.s3 + distribution.s4plus;

  if (total === 0) {
    return (
      <section className="flex flex-col gap-2">
        <h3 className="text-muted-foreground text-xs font-medium tracking-wider uppercase">
          Active words by streak
        </h3>
        <p className="bg-muted/40 text-muted-foreground rounded-md p-4 text-sm">
          No active learning words yet. Practice a session to see this fill in.
        </p>
      </section>
    );
  }

  return (
    <section className="flex flex-col gap-2">
      <h3 className="text-muted-foreground text-xs font-medium tracking-wider uppercase">
        Active words by streak
      </h3>
      <div className="flex h-12 overflow-hidden rounded-md">
        {BUCKETS.map((bucket) => {
          const value = distribution[bucket.key];
          const pct = (value / total) * 100;
          if (pct === 0) return null;
          return (
            <div
              key={bucket.key}
              className="text-foreground/80 flex items-center justify-center text-xs font-medium transition-all"
              style={{ width: `${pct}%`, background: bucket.color }}
              title={`Streak ${bucket.label}: ${value} word${value === 1 ? '' : 's'}`}
            >
              {pct > 8 ? `${bucket.label} · ${value}` : value}
            </div>
          );
        })}
      </div>
      <div className="text-muted-foreground flex justify-between text-xs">
        {BUCKETS.map((b) => (
          <span key={b.key}>
            {b.label}: {distribution[b.key]}
          </span>
        ))}
      </div>
    </section>
  );
}
